var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"overlay",class:{
      'overlay': true,
      'is-open': _vm.isOpen === true,
    }}),_c('div',{ref:"panel",class:{
      'panel': true,
      'is-left': _vm.position === 'left',
      'is-right': _vm.position === 'right',
      'is-open': _vm.isOpen === true,
      'is-xs': _vm.size === 'xs',
      'is-sm': _vm.size === 'sm',
      'is-md': _vm.size === 'md',
      'is-lg': _vm.size === 'lg',
      'is-xl': _vm.size === 'xl',
    }},[_c('div',{staticClass:"panel-header"},[(_vm.title)?_c('h2',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]):_vm._e(),_c('span',{staticClass:"close"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.hide($event)}}},[_c('i',{staticClass:"el-icon-fa-times"})])])]),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }